class MFRImpactSection {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            selector: ".impact-section__selector",
            selectorOptions: ".impact-section__selector-options",
            selectorCTA: ".impact-section__selector-cta",
            productSelector: '[data-selector="product"]',
            multipliersSelector: '[data-for]',
            carousel: ".impact-section__carousel"
        }

        this.init();
    }

    init() {
        this.$selector = this.$element.find( this.selectors.selector );
        this.$carousel = this.$element.find( this.selectors.carousel );
        this.$selectorOption = this.$element.find( this.selectors.selectorOptions + " .option" );
        const initialSelectedProduct = this.$element
            .find( this.selectors.selectorCTA + this.selectors.productSelector )
            .closest( this.selectors.selector )
            .data( "selected" );

        this.showHideMultipliers( initialSelectedProduct );
        this.initCarousels();

        this.$selectorOption.on( "click", this.__handleSelectorOptionClick.bind( this ) );
        $( document ).on( "mfr--impact-changed", this.__handleImpactChange.bind( this ) );
    }

    __handleSelectorOptionClick( e ) {
        const element = $( e.currentTarget )
        const selector = element.closest( this.selectors.selector );
        const value = element.data( "value" );
        const text = element.text();
        const cta = selector.find( this.selectors.selectorCTA );

        selector.data( "selected", value );
        cta.removeClass( "hover" );
        cta.attr( "aria-expanded", "false" );
        cta.text( text );

        selector.find( this.selectors.selectorOptions )
            .attr( "aria-hidden", "true" )
            .removeClass( "is-open" );

        $( document )
            .trigger( "mfr--impact-changed", [
                { 
                    type: cta.data( "selector" ), 
                    value: value
                }
            ] );
    }

    __handleImpactChange( e, data ) {
        const { type, value } = data;
      
        if( type == "product" ) {
            this.showHideMultipliers( value );
            this.showHideCarousels( value );
        }

        if( type == "multiplier" ) {
            this.updateValues( value );
        }
    }

    showHideMultipliers( product ) {
        this.$element
            .find( this.selectors.selector + this.selectors.multipliersSelector )
            .removeClass( "show" )

        this.$element
            .find( this.selectors.selector + `[data-for="${ product }"]` )
            .addClass( "show" );
    }

    showHideCarousels( product ) {
        this.$element.find( this.selectors.carousel ).hide();
        this.$element
            .find( this.selectors.carousel + `[data-for="${ product }"]` )
            .show()
            .flickity( "resize" );
    }

    updateValues( multiplier ) {
        const selector = this.$element
            .find( this.selectors.selectorCTA + this.selectors.productSelector )
            .closest( this.selectors.selector )
            .data( "selected" );
        const carousel = this.$element
            .find( this.selectors.carousel + `[data-for="${ selector }"]` )

        const xValues = carousel.find( "[data-x]" );
        const yValues = carousel.find( "[data-y]" );

        this.processValues( xValues, multiplier );
        this.processValues( yValues, multiplier );
    }

    processValues( values, multiplier ) {
        $.each( values, ( i, e ) => {
            const value = ( $( e ).data( "value" ) % 1 != 0 ) ? ($( e ).data( "value" ) * multiplier).toFixed(1) : $( e ).data( "value" ) * multiplier;
            // $( e ).text( value );
            if( $( e ).data( "value" ) % 1 != 0 || $( e ).text() % 1 != 0 || value % 1 != 0 )
                $( e ).text( value );
            else
                this.animateValue( $( e ), $( e ).text(), value, 500 );
        } );
    }

    animateValue(obj, start, end, duration) {
        let startTimestamp = null;
        start = ( start % 1 != 0 ) ? parseFloat(start).toFixed(1) : parseInt(start);
        end = ( end % 1 != 0 ) ? parseFloat(end).toFixed(1) : parseInt(end);
        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);
          obj.text( Math.floor(progress * (end - start) + start) );
          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        };
        window.requestAnimationFrame(step);
    }

    initCarousels() {
        this.$carousel.flickity( {
            pageDots: true,
            contain: true,
            wrapAround: true,
            adaptiveHeight: true,
            autoplay: false,
            prevNextButtons: true
        } );
    }
}